<template>
  <div class="view-container">
    <BjDrawerForm ref="BjDrawerForm" :form="form" label-position="top" :rules="rules" label-width="120px" @handleConfirm="handleConfirm">
      <BjDivider>{{ $t('ChannelManagement.new.title') }}</BjDivider>
      <el-col :span="24">
        <el-form-item :label="$t('billingPage.DisableDate')" prop="date">
          <BjDatePicker v-model="form.date" :placeholder="$t('billingPage.DisableDate')" @change="timeChange" />
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item :label="$t('table.remarkText')" prop="remarks">
          <el-input v-model="form.remarks" :maxlength="MAX_LENGTH.NORMAL_REMARK" type="textarea" show-word-limit autosize :placeholder="$t('table.remarkText')" />
        </el-form-item>
      </el-col>
    </BjDrawerForm>
  </div>
</template>
<script>
import { purchaseApi } from '@/api';
import moment from 'moment';

const getDefaultForm = () => {
  return {
    date: null,
    remarks: null,
  };
};

export default {
  data() {
    return {
      // 表单参数
      isEdit: false,
      form: getDefaultForm(),
      // 表单校验
      rules: {
        date: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        remarks: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      },
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    timeChange(time) {
      this.form.date = moment(time).format('YYYY-MM-DD HH:mm:ss');
    },
    show(info) {
      this.isEdit = !!info;
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(
        this.isEdit ? this.$t('editText') : this.$t('addText'),
      );
      this.form = Object.assign(getDefaultForm(), info || {});
    },
    handleConfirm() {
      const API_DATA = this.$lodash.clone(this.form);
      if (this.isEdit) {
        API_DATA['_innerMap'] = {};
        purchaseApi.putCsgPurchaseOrderTimeList(API_DATA).then(res => {
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.$refs.BjDrawerForm.hide();
              this.reFresh();
            }, 500);
          }
        });
      } else {
        API_DATA['_innerMap'] = {};
        purchaseApi.addCsgPurchaseOrderTimeList(API_DATA).then(res => {
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.$refs.BjDrawerForm.hide();
              this.reFresh();
            }, 500);
          }
        });
      }
    },
    reFresh() {
      this.$emit('reFresh');
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
::v-deep .el-checkbox__label {
  width: 125px;
  height: 30px;
}
</style>
